var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "factors-viz-container", style: _vm.containerStyle },
    [
      _vm.error
        ? _c("div", { staticClass: "error-alert" }, [
            _vm._v(" " + _vm._s(_vm.error) + " "),
          ])
        : _vm._e(),
      _vm.useFactorBaseRevealData && _vm.phenotypeOptions.length
        ? _c(
            "div",
            { staticClass: "mb-2 d-flex align-items-center gap-2" },
            [
              _c(
                "label",
                {
                  staticClass: "mb-0 font-weight-bold small text-secondary",
                  attrs: { for: "fbr-heatmap-phenotype-select" },
                },
                [_vm._v("Phenotype:")]
              ),
              _c("b-form-select", {
                staticClass: "form-control form-control-sm",
                staticStyle: { "max-width": "280px" },
                attrs: {
                  id: "fbr-heatmap-phenotype-select",
                  options: _vm.phenotypeOptions,
                  size: "sm",
                },
                model: {
                  value: _vm.selectedPhenotype,
                  callback: function ($$v) {
                    _vm.selectedPhenotype = $$v
                  },
                  expression: "selectedPhenotype",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.loading &&
      (_vm.useFactorBaseRevealData
        ? _vm.heatmapDataFromFactorData && _vm.heatmapDataFromFactorData.ready
        : _vm.heatmapData &&
          _vm.heatmapData.genes &&
          _vm.heatmapData.genes.length > 0)
        ? _c("div", { staticClass: "viz-legend" }, [
            _vm._m(0),
            _c("div", { staticClass: "legend-actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-primary",
                  on: { click: _vm.downloadHeatmap },
                },
                [_vm._v(" Download ")]
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "heatmap-container",
          attrs: { id: "factor-base-reveal-heatmap-wrapper" },
        },
        [
          _vm.useFactorBaseRevealData &&
          (!_vm.heatmapDataFromFactorData ||
            !_vm.heatmapDataFromFactorData.ready)
            ? _c("div", { staticClass: "text-center p-3 text-muted" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.useFactorBaseRevealData &&
                        _vm.phenotypeOptions.length &&
                        !_vm.selectedPhenotype
                        ? "Select a phenotype."
                        : "No factor data to plot."
                    ) +
                    " "
                ),
              ])
            : !_vm.useFactorBaseRevealData &&
              (!_vm.heatmapData ||
                !_vm.heatmapData.genes ||
                _vm.heatmapData.genes.length === 0)
            ? _c("div", { staticClass: "text-center p-3 text-muted" }, [
                _vm._v(" Loading heatmap data... "),
              ])
            : _c("div", { staticClass: "heatmap-scrollable-wrapper" }, [
                _c("div", {
                  ref: "heatmapLabelsContainer",
                  staticClass: "heatmap-labels-fixed",
                }),
                _c("div", {
                  ref: "heatmapContainer",
                  staticClass: "heatmap-content-scrollable",
                }),
              ]),
        ]
      ),
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [
            _vm._v("Loading visualization..."),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "legend-content" }, [
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-label" }, [
          _vm._v("Phenotype associations:"),
        ]),
        _c("span", { staticClass: "legend-color-item" }, [
          _c("span", { staticClass: "legend-color very-strong" }),
          _c("span", { staticClass: "legend-color-text" }, [
            _vm._v("Very Strong (> 3)"),
          ]),
        ]),
        _c("span", { staticClass: "legend-color-item" }, [
          _c("span", { staticClass: "legend-color strongly-suggestive" }),
          _c("span", { staticClass: "legend-color-text" }, [
            _vm._v("Strongly Suggestive (2-3)"),
          ]),
        ]),
        _c("span", { staticClass: "legend-color-item" }, [
          _c("span", { staticClass: "legend-color nominally-significant" }),
          _c("span", { staticClass: "legend-color-text" }, [
            _vm._v("Nominally Significant (1-2)"),
          ]),
        ]),
        _c("span", { staticClass: "legend-color-item" }, [
          _c("span", { staticClass: "legend-color not-significant" }),
          _c("span", { staticClass: "legend-color-text" }, [
            _vm._v("Not Significant (< 1)"),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "legend-item" }, [
        _c("span", { staticClass: "legend-label" }, [
          _vm._v("Gene set cluster relevance:"),
        ]),
        _c("span", { staticClass: "legend-color factor-relevance" }),
        _c("span", { staticClass: "legend-text" }, [
          _vm._v("Darker = more relevant"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }